import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { spacing } from '@naf/theme';

export const IconWrapper = styled.div`
  display: flex;
  font-size: 1rem;
  line-height: 1.5rem;
  flex-direction: column;

  svg {
    margin-right: 13px;
    padding: 0;
  }
`;

export const IconSet = styled.div`
  display: flex;
  align-items: center;
  margin-right: ${spacing.space20};
  padding-bottom: 5px;

  b {
    font-weight: 500;
  }
`;

export const ShowMoreWrapper = styled.div<{ $isHidden?: boolean; $height: number }>`
  max-height: ${(props) => props.$height}px;
  transition: max-height 1s ease-in;

  ${({ $isHidden }) =>
    $isHidden &&
    css`
      max-height: 0;
      overflow: hidden;
    `}
`;

export const RelatedList = styled.ul`
  padding: 0;
  margin: 0;
`;

export const RelatedListItem = styled.li`
  padding-top: ${spacing.space24};
  list-style-type: none;

  a {
    padding-bottom: ${spacing.space24} !important;
  }
`;
